import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {useEffect, useRef, useState} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {createFile, downloadFile, getFiles} from "./integracion";
import Swal from "sweetalert2";
import * as fileApi from "../../administracion/GestorDeArchivos/integracion";
import UseGetDataUser from "../../../utilidades/customHooks/useGetDataUser";

const toUnderscoreName = (str) =>
    str.trim().replace(/\s+/g, '_');
const DocumentTable = ({onApply, reqDocuments, nombre}) => {

    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [activeDoc, setActiveDoc] = useState(null);
    const [expedientes, setExpedientes] = useState([])
    const [rows, setRows] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [renamedFile, setRenamedFile] = useState(null);
    const fileInputRef = useRef(null);

    const base_url_exp = `Expedientes/Personal/OPERADORES/${toUnderscoreName(nombre)}`

    const dataUser = UseGetDataUser()
    const getExt = (name = "") => {
        const i = name.lastIndexOf(".");
        return i >= 0 ? name.slice(i) : "";
    };

    const normalize = (s = '') =>
        s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();


    const stripExt = (name = '') => name.replace(/\.[^.]+$/, '');


    const estatusTemplate = (rowData) => {
        return rowData.estatus === 'completo'
            ? <i className="pi pi-check-circle" style={{color: 'green', marginLeft: '8px'}}/>
            : <i className="pi pi-times-circle" style={{color: 'red', marginLeft: '8px'}}/>;
    };


    const enrichWithStatus = (reqDocs = [], files = []) => {
        const normalizedFiles = files
            .filter(f => f.isFile)
            .map(f => ({
                raw: f,
                normName: normalize(stripExt(f.name))
            }));

        return reqDocs.map(d => {
            const key = normalize(d.DOCUMENTO || d.documento || '');
            console.log("normalized doc", key)
            const match = normalizedFiles.find(f => f.normName.includes(key));
            return {
                ...d,
                estatus: match ? 'completo' : 'pendiente',
                fecha: match?.raw.lastModified
                    ? new Date(match.raw.lastModified).toLocaleDateString('es-MX')
                    : null
            };
        });
    };

    useEffect(() => {
        const fetchAndMap = async () => {
            try {
                const items = await getFiles(base_url_exp);
                const enriched = enrichWithStatus(reqDocuments, items);
                setRows(enriched);
            } catch (error) {
                console.error('Error al cargar los expedientes:', error);
                setRows((reqDocuments || []).map(d => ({...d, estatus: 'pendiente', fecha: null})));
            }
        };
        fetchAndMap();
    }, [base_url_exp, reqDocuments]);


    const addRecordTemplate = (rowData) => (
        <Button icon="pi pi-cloud-upload" className="p-button-text p-button-warning"
                onClick={() => openUploadDialog(rowData)} aria-label="Agregar/Editar"/>
    );

    const downloadButtonTemplate = (rowData) => {
        return rowData.estatus === 'completo'
            ? <Button icon="pi pi-download" className="p-button-text p-button-warning"
                      onClick={() => handleDownload(rowData)}></Button>
            : null
    }

    const handleDownload = async (rowData) => {
        Swal.fire({
            title: 'Descargando...',
            text: 'Descargando el archivo',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => Swal.showLoading()
        })
        const filePath = rowData.downloadPath;
        const fileName = rowData.matchName;
        const userId = dataUser.user.ID;
        await downloadFile(filePath, fileName, userId);

    }


    const openUploadDialog = (rowData) => {
        setActiveDoc(rowData);
        setSelectedFile(null);
        setUploadDialogOpen(true);
    };

    const closeUploadDialog = () => {
        setUploadDialogOpen(false);
        setActiveDoc(null);
        setSelectedFile(null);
        setRenamedFile(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    const onChangeFile = (e) => {
        const f = e.target.files?.[0] ?? null;
        setSelectedFile(f);


        if (f && activeDoc?.DOCUMENTO) {
            const ext = getExt(f.name);
            const baseName = toUnderscoreName(String(activeDoc.DOCUMENTO));
            const newName = `${baseName}${ext}`;

            try {
                const nf = new File([f], newName, {type: f.type, lastModified: f.lastModified});
                setRenamedFile(nf);
            } catch {
                setRenamedFile(f);
            }
        } else {
            setRenamedFile(f || null);
        }
    };

    const triggerFilePicker = () => {
        fileInputRef.current?.click();

    };

    const handleApply = async () => {

        if (!renamedFile) return;

        try {
             Swal.fire({
                title: 'Subiendo...',
                text: 'Estamos guardando tu archivo',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => Swal.showLoading()
            });

            const res = await handleCreateFile(renamedFile)

            if (res.success) {
                await Swal.fire({
                    icon: 'success',
                    title: 'Archivo subido',
                    timer: 1400,
                    showConfirmButton: false
                });
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error al subir',
                    text: res.message
                });
            }
            await Swal.fire({
                icon: 'success',
                title: 'Archivo subido',
                timer: 1400,
                showConfirmButton: false
            });

            try {
                const items = await getFiles(base_url_exp);
                const enriched = enrichWithStatus(reqDocuments, items);
                setRows(enriched);
            } catch (e) {

                setRows((reqDocuments || []).map(d => ({...d, estatus: 'pendiente', fecha: null})));
            }
        } catch (e) {
            await Swal.fire({
                icon: 'error',
                title: 'Error al subir',
                text: e?.response?.data?.message || 'No se pudo completar la carga. Intenta de nuevo.'
            });
        } finally {
            Swal.close();
            closeUploadDialog();
        }
    };


    const handleCreateFile = async (file) => {

        try {
            const res = await fileApi.createFile(file, base_url_exp, dataUser.user.ID);
            console.log("respuesta", res)
            return {success: true, message: 'Archivo subido con éxito.'};
        } catch (err) {
            console.error('Error al subir archivo:', err);
            const errorMessage = err.response?.data?.message || 'Error desconocido al subir el archivo.';
            return {success: false, message: errorMessage};
        }
    };


    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                style={{display: "none"}}
                onChange={onChangeFile}
            />

            <DataTable value={rows}>
                <Column header="ESTATUS" body={estatusTemplate} style={{width: '10%'}}></Column>

                <Column field="DOCUMENTO" header="DOCUMENTO"></Column>
                <Column header="DESCARGAR" body={downloadButtonTemplate} style={{width: '12%'}}></Column>
                <Column header="AGREGAR REGISTRO" body={addRecordTemplate} style={{width: '12%'}}></Column>
            </DataTable>

            <Dialog
                header={activeDoc ? `Agregar registro: ${activeDoc.DOCUMENTO}` : 'Agregar registro'}
                visible={uploadDialogOpen}
                modal
                style={{width: '32rem', maxWidth: '95vw'}}
                onHide={closeUploadDialog}
                footer={
                    <div style={{display: 'flex', gap: 8, justifyContent: 'flex-end'}}>
                        <Button label="Cancelar" icon="pi pi-times" className="p-button-text"
                                onClick={closeUploadDialog}/>
                        <Button label="Aplicar" icon="pi pi-check" onClick={handleApply} disabled={!selectedFile}/>
                    </div>
                }
            >
                <div style={{display: "grid", gap: 12}}>
                    <div>
                        <label style={{display: 'block', fontWeight: 600, marginBottom: 6}}>Archivo local</label>
                        <div style={{display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap'}}>
                            <Button icon="pi pi-upload" label="Seleccionar archivo" onClick={triggerFilePicker}/>
                            <span>
                                {renamedFile
                                    ? `Archivo: ${renamedFile.name}`
                                    : (selectedFile ? selectedFile.name : "Ningún archivo seleccionado")}
                            </span></div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default DocumentTable;